import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", this.uniqueId)
    const fragment = document.createRange().createContextualFragment(content)
    const positionField = fragment.querySelector('input[name$="[position]"]')

    if (positionField) positionField.value = this.nextPosition

    this.containerTarget.appendChild(fragment)
  }

  get uniqueId() {
    return `${Date.now()}${Math.floor(Math.random() * 100000)}`
  }

  get nextPosition() {
    return this.containerTarget.querySelectorAll('[data-sortable-list-target~="item"]').length
  }
}
